import { MakeLogicType, connect, kea, key, path, props, selectors } from 'kea'

import { propertyDefinitionsModel } from '~/models/propertyDefinitionsModel'
import { PropertyDefinitionType } from '~/types'

import type { Option } from '../../../../models/propertyDefinitionsModel'

export interface PropertyValueLogicProps {
    propertyKey: string
    type: PropertyDefinitionType
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface propertyValueLogicValues {
    options: Record<string, Option> // propertyDefinitionsModel
    isRefreshing: boolean
    propertyOption: Option
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface propertyValueLogicMeta {
    key: string
    __keaTypeGenInternalSelectorTypes: {
        propertyOption: (options: Record<string, Option>) => Option
        isRefreshing: (propertyOption: Option) => boolean
    }
}

export type propertyValueLogicType = MakeLogicType<
    propertyValueLogicValues,
    {},
    PropertyValueLogicProps,
    propertyValueLogicMeta
>

export const propertyValueLogic = kea<propertyValueLogicType>([
    path(['lib', 'components', 'PropertyFilters', 'propertyValueLogic']),
    props({} as PropertyValueLogicProps),
    key((props) => `${props.type}/${props.propertyKey}`),
    connect(() => ({ values: [propertyDefinitionsModel, ['options']] })),
    selectors(({ props }) => ({
        propertyOption: [
            (s) => [s.options],
            (options: Record<string, import('~/models/propertyDefinitionsModel').Option>) => options[props.propertyKey],
        ],
        /** Whether a background cache refresh is currently in progress for this property. */
        isRefreshing: [
            (s) => [s.propertyOption],
            (propertyOption: import('~/models/propertyDefinitionsModel').Option): boolean =>
                propertyOption?.refreshing ?? false,
        ],
    })),
])
